import type { LinkProps } from "@mui/material";
import Link from "@mui/material/Link";
import React from "react";

export const MDDDLink = (props: Omit<LinkProps, "href" | "rel">) => (
  <Link href="https://www.mddd.nl" rel="author noopener" {...props}>
    Built by MDDD © {new Date().getFullYear()}
  </Link>
);
